import { useEffect, useRef, useState } from "react";

const KEY = "arcana-music";

export const getMusicPref = () => localStorage.getItem(KEY) === "on";

export const setMusicPref = (on) => {
  localStorage.setItem(KEY, on ? "on" : "off");
  window.dispatchEvent(new CustomEvent("arcana-music", { detail: on }));
};

export const AmbientAudio = () => {
  const audioRef = useRef(null);
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    const audio = new Audio("/audio/ambient.wav");
    audio.loop = true;
    audio.volume = 0.12;
    audioRef.current = audio;
    const onPref = (e) => setEnabled(e.detail);
    window.addEventListener("arcana-music", onPref);
    const reset = setTimeout(() => {
      if (getMusicPref()) setMusicPref(false);
    }, 0);
    return () => {
      clearTimeout(reset);
      audio.pause();
      window.removeEventListener("arcana-music", onPref);
    };
  }, []);

  useEffect(() => {
    const audio = audioRef.current;
    if (!audio) return;
    if (enabled) audio.play().catch(() => setEnabled(false));
    else audio.pause();
  }, [enabled]);

  useEffect(() => {
    const onVis = () => {
      const audio = audioRef.current;
      if (!audio) return;
      if (document.hidden) audio.pause();
      else if (enabled) audio.play().catch(() => {});
    };
    document.addEventListener("visibilitychange", onVis);
    return () => document.removeEventListener("visibilitychange", onVis);
  }, [enabled]);

  return null; // nessun pulsante fluttuante: il controllo musica vive nel pannello Impostazioni
};
